export default {
    getRanking (state) {
        return state.ranking
    }
}